import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Rx';

import { Project } from '../project.model';
import { UserAccess } from '../project.model';
import { ProjectService } from '../project.service';

declare var $: any;

@Component({
 selector: 'wm-project-edit-access',
 template: require('./project-edit-access.component.html')
})
export class ProjectEditAccessComponent implements OnInit, OnChanges {
  @Input() user: UserAccess;
  @Input() project: Project;
  @Output() projectUpdate = new EventEmitter();


  projectAccessForm: FormGroup;
  submitted: boolean;


  formErrors = {'wmid': ''};

  validationMessages  = {
    'wmid': {
      required: 'wmid не может быть пустым',
      pattern: 'Wmid: 12 цифр'
    }
  };


  constructor(
    private fb: FormBuilder,
    private service: ProjectService
  ) { }

  ngOnInit() {
    this.buildForm();
    this.submitted = false;
  }

  buildForm() {
    this.projectAccessForm = this.fb.group({
      wmid: ['', [Validators.required, Validators.pattern]],
      mode: ['ro']
    });
  }

  hideEditForm() {
    $('.edit-access-form').removeClass('show');

    if (!!this.project && !!this.project.id) {
      let position = $('#' + this.project.id).offset().top - 150;
      $('html, body').animate({ scrollTop: position }, 'slow');
    }

    this.projectUpdate.emit(undefined);

    this.formErrors = {'wmid': ''};
    this.buildForm();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (!!this.user &&  this.projectAccessForm) {
      this.projectAccessForm.patchValue({
        wmid: this.user.wmid,
        mode: this.user.mode
      });
    }
  }

  onSubmit(model: UserAccess, valid: boolean) {
    this.submitted = true;

    if (!valid) {
      this.validateForm();

      return false;
    }
    if (!!this.user && !!this.user.wmid) {
      this.service.updateUserAccess(this.project.id, model).subscribe(result => {
        this.projectUpdate.emit(result['project']);
        this.hideEditForm();
      });
    } else {
      this.service.createUserAccess(this.project.id, model).subscribe(result => {
        this.projectUpdate.emit(result['project']);
        this.hideEditForm();
      });
    }

    return false;
  }

  deleteUserAccess(model: UserAccess, event) {
    this.service.deleteUserAccess(this.project.id, model).subscribe(result => {
      this.projectUpdate.emit(result['project']);
      this.hideEditForm();
    });

    event.stopPropagation();
  }

  validateForm() {
    for (let field of Object.keys(this.formErrors)) {
      this.formErrors[field] = '';
      let input = this.projectAccessForm.get(field);

      if ((input.invalid && input.dirty) || this.submitted) {
        if (!!input.errors) {
          for (let error of Object.keys(input.errors)) {
            this.formErrors[field] = this.validationMessages[field][error];
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/projects/components/project-edit-access.component.ts